import {$qsAll} from '../../../@shared/ts/dom';
import {type CheckoutData} from '../models/CheckoutData';
import {MerchantConfiguration, updateMerchantCurrencyConfig} from '../reducers/merchantConfigurationReducer';
import {store} from '../store';

export function initCurrency(checkoutData: CheckoutData) {
	initCurrencyEvents();

	store.dispatch(updateMerchantCurrencyConfig({
		name: checkoutData.currency_info?.name ?? 'United States Dollar',
		code: checkoutData.currency_info?.code ?? 'USD',
		symbol: checkoutData?.currency_info?.symbol ?? '$',
		thousands_separator: checkoutData.currency_info?.thousands_separator ?? ',',
		decimal_separator: checkoutData.currency_info?.decimal_separator ?? '.',
		number_of_decimals: checkoutData.currency_info?.number_of_decimals ?? 2,
		position: checkoutData.currency_info?.position ?? 'left',
		rounding: checkoutData.currency_info?.rounding ?? 'disabled',
		hidden: checkoutData.currency_info?.hidden ?? false,
	}));
}

function initCurrencyEvents() {
	// Set currency symbols whenever the modal currency state changes.
	store.subscribe(() => {
		renderCurrencySymbols();
	});
}

/**
 * Renders the text content of all elements with the class
 * ".currency-symbol,.currency-symbol-after" with the
 * current currency values.
 */
function renderCurrencySymbols() {
	const {position, symbol} = MerchantConfiguration.currency.configuration();

	const right = position === 'right' || position === 'right_space';
	for (const $element of $qsAll(`.currency-symbol${right ? '-after' : ''}`)) {
		$element.innerHTML = symbol;
	}
}
